import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, allowedRoles, allowedPerms }) => {
  const { user, loading, hasPermission } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#0A0A0A]">
        <div className="text-[#D4AF37] text-xl">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // iter160 — Phase D: a route passes if EITHER the role matches OR any of the
  // allowedPerms is granted. Super_admin/admin always pass (hasPermission()
  // returns true for them).
  //
  // iter161 — Fix critical leak found in production: when `allowedPerms` was
  // undefined, the previous `permOk = !allowedPerms || ...` short-circuited to
  // `true`, which let office_staff load /admin/trash, /admin/system, etc.
  // We now treat an absent allowedPerms array as "no perm path" (closed), so
  // the guard blocks unless an explicit role OR explicit perm matches.
  const hasRoleGate = Array.isArray(allowedRoles) && allowedRoles.length > 0;
  const hasPermGate = Array.isArray(allowedPerms) && allowedPerms.length > 0;
  const roleOk = hasRoleGate ? allowedRoles.includes(user.role) : false;
  const permOk = hasPermGate ? allowedPerms.some((p) => hasPermission(p)) : false;
  if (hasRoleGate || hasPermGate) {
    if (!roleOk && !permOk) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;